import React from "react"
import { Checkbox as MuiCheckbox, CheckboxProps } from "@mui/material"

export type PrimitiveCheckboxProps = CheckboxProps

export const PrimitiveCheckbox = (props: PrimitiveCheckboxProps) => {
	return <MuiCheckbox {...props} />
}
